import { Button, Typography, useTheme } from "@monolith-forensics/monolith-ui";
import { useState } from "react";
import { RemoveUserConfirmModal } from "../Modals";

export const RemoveUserSection: React.FC<{
  user: any;
  relayInfo: any;
  onSubmit?: () => void;
}> = ({ user, relayInfo, onSubmit }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleRemove = () => setOpen(true);

  return (
    <div>
      <Typography variant="h3" display="inline">
        Remove User
      </Typography>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ color: theme.palette.text.secondary, marginTop: 5 }}>
          This will remove this user's access to your Relay Tenant.
        </div>
        <Button
          variant="contained"
          color="primary"
          size="xs"
          onClick={handleRemove}
        >
          Remove User
        </Button>
      </div>
      <RemoveUserConfirmModal
        defaultInfo={{ ...relayInfo, ...user }}
        show={open}
        onClose={handleClose}
        onCancel={handleClose}
        onSubmit={onSubmit}
      />
    </div>
  );
};
